import { getStorageState } from 'redux-simple-storage-middleware';
export var getSessionStorageKey = function getSessionStorageKey(key) {
  var sessionStorage = getStorageState({
    key: 'persist:cb-ds'
  });

  if (!sessionStorage) {
    var _sessionStorage;

    //storybook
    sessionStorage = getStorageState({
      key: 'cb-ds-test'
    });
    return ((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage[key]) ? sessionStorage[key] : null;
  } else {
    var _sessionStorage2;

    return ((_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2[key]) ? JSON.parse(sessionStorage[key]) : null;
  }
};